import articleComponent from './article.component';

let articleModule = angular.module('article', [
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $stateProvider
    .state('article', {
      url: '/article',
      template: '<article></article>'
    })
    .state('article.html', {
      url: '/article.html',
      template: '<article></article>'
    })
})

.component('article', articleComponent);

export default articleModule;



// WEBPACK FOOTER //
// ./app/components/article/article.js